import { Box } from '@chronosphereio/chrono-ui';
import { memo } from 'react';

const ZOOM_BUTTON_SX = {
  cursor: 'pointer',
  color: 'text.secondary',
  '&:hover': { color: 'text.primary' },
  userSelect: 'none',
  fontSize: 9,
  fontWeight: 500,
  padding: '0 3px',
  borderRadius: 1,
  backgroundColor: 'action.hover',
  lineHeight: 1.3,
} as const;

export interface YZoomControlsProps {
  left: number;
  top: number;
  width: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export const YZoomControls = memo(function YZoomControls({
  left,
  top,
  width,
  onZoomIn,
  onZoomOut,
  onReset,
}: YZoomControlsProps) {
  return (
    <Box
      onMouseDown={(e) => e.stopPropagation()}
      style={{ position: 'absolute', left, top, width }}
      sx={{
        zIndex: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2px',
        pointerEvents: 'auto',
      }}
    >
      <Box sx={ZOOM_BUTTON_SX} onClick={onZoomIn}>
        +
      </Box>
      <Box sx={ZOOM_BUTTON_SX} onClick={onZoomOut}>
        −
      </Box>
      <Box sx={ZOOM_BUTTON_SX} onClick={onReset}>
        ↺
      </Box>
    </Box>
  );
});
